import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  StampsTermsAndConditions: {
    description: 'Stamps terms and conditions label',
    defaultMessage: 'Stamps.com Terms and Conditions',
    id: 'A1noBG',
  },
  StampsPrivacyPolicy: {
    description: 'Stamps privacy T&C label',
    defaultMessage: 'Stamps.com Privacy Policy',
    id: 'SI+/eb',
  },
  UpsPromotionalRatesAgreement: {
    description: 'Ups promotional rates T&C label',
    defaultMessage: 'UPS Promotional Rates Agreement',
    id: '8wbca8',
  },
  UpsTechnologyAgreement: {
    description: 'UPS technology agreement T&C label',
    defaultMessage: 'UPS Technology Agreement',
    id: '03O9v0',
  },
  UpsProhibitedItems: {
    description: 'UPS list of prohibited items',
    defaultMessage: 'List of Prohibited Items',
    id: 'nL/ROJ',
  },
  UpsSupplementalTerms: {
    description: 'UPS Supplemental Terms and Conditions',
    defaultMessage: 'UPS Supplemental Terms and Conditions',
    id: 'RdsFhR',
  },
  UpsDangerousGoods: {
    description: 'UPS Hazardous Materials & Dangerous Goods',
    defaultMessage: 'UPS Hazardous Materials & Dangerous Goods',
    id: 'psn4BF',
  },
  UpsPaperlessInvoice: {
    description: 'Acknowledgment for UPS Paperless Invoice and/or UPS Paperless USMCA Enrollment',
    defaultMessage: 'Acknowledgment for UPS Paperless Invoice and/or UPS Paperless USMCA Enrollment',
    id: 'DVC12t',
  },
  OneBalanceTerms: {
    description: 'One Balance T&C label`',
    defaultMessage: 'One Balance Terms of Service',
    id: 'zXPWJQ',
  },
  UberWalletedTerms: {
    description: 'Uber terms and conditions for wallet registration',
    defaultMessage: 'Uber Terms and Conditions',
    id: 'cJ5GyA',
  },
  PurolatorWalletTerms: {
    description: 'Purolator terms and conditions for wallet registration',
    defaultMessage: 'Purolator Terms and Conditions',
    id: '2njzqs',
  },
  GlobalPostWalletTerms: {
    description: 'GlobalPost terms and conditions for wallet registration',
    defaultMessage: 'GlobalPost Terms and Conditions',
    id: 'WzqaED',
  },
  SendleWalletTerms: {
    description: 'Sendle terms and conditions for wallet registration',
    defaultMessage: 'Sendle Terms and Conditions',
    id: 'A73m0w',
  },
  SendleDangerousGoods: {
    description: 'Sendle Hazardous Materials & Dangerous Goods',
    defaultMessage: 'Sendle Hazardous Materials & Dangerous Goods',
    id: 'p8zOen',
  },
  ParcelGuardTerms: {
    description: 'ParcelGuard Terms and Conditions',
    defaultMessage: 'ParcelGuard Terms and Conditions',
    id: 'z2FUwx',
  },
  XCoverTerms: {
    description: 'Total Shipping Protection Terms and Conditions',
    defaultMessage: 'Total Shipping Protection Terms and Conditions',
    id: 'JpdkfY',
  },
  XCoverInformation: {
    description: 'Insurance Product Information Document for Total Shipping Protection',
    defaultMessage: 'Insurance Product Information Document for Total Shipping Protection',
    id: '44IaVh',
  },
  YodelWalletTerms: {
    description: 'InPost Terms and Conditions',
    defaultMessage: 'InPost Terms and Conditions',
    id: 'ILKTxL',
  },
  FedExWalletTerms: {
    description: 'FedEx One Balance Terms and Conditions',
    defaultMessage: 'FedEx One Balance Terms and Conditions',
    id: 'cxSA4s',
  },
  DHLExpressCAWalletTerms: {
    description: 'DHL Express Canada terms and conditions for wallet registration',
    defaultMessage: 'DHL Express Canada Terms and Conditions',
    id: '7RPmGd',
  },
  StampsDHLExpressTerms: {
    description: 'DHL Express United States terms and conditions for wallet registration',
    defaultMessage: 'DHL Express United States Terms and Conditions',
    id: 'MJqXen',
  },
  EVRiWalletTerms: {
    description: 'EVRi terms and conditions for wallet registration',
    defaultMessage: 'EVRi Terms and Conditions',
    id: 'JqVwYv',
  },
  ParcelforceWalletTerms: {
    description: 'Parcelforce terms and conditions for wallet registration',
    defaultMessage: 'Parcelforce Terms and Conditions',
    id: 'SFw+Sm',
  },
  DpdWalletTerms: {
    description: 'DPD terms and conditions for wallet registration',
    defaultMessage: 'DPD Terms and Conditions',
    id: 'mxiaKV',
  },
  DHLEcommerceTerms: {
    description: 'DHL eCommerce terms and conditions for wallet registration',
    defaultMessage: 'DHL eCommerce Terms and Conditions',
    id: 'bFYc51',
  },
  DHLEcommerceDDPTerms: {
    description: 'DHL Duty & Tax Calculator Terms and Conditions for wallet registration',
    defaultMessage: 'DHL Duty & Tax Calculator Terms and Conditions',
    id: '2iBXNk',
  },
  SendleCAWalletTerms: {
    description: 'Sendle Canada terms and conditions for wallet registration',
    defaultMessage: 'Sendle Canada Terms and Conditions',
    id: 'gwQR7D',
  },
  SendleCAWalletDangerousGoods: {
    description: 'Sendle Canada Hazardous Materials & Dangerous Goods',
    defaultMessage: 'Sendle Canada Hazardous Materials & Dangerous Goods',
    id: 'jN1BSd',
  },
  BrtItWalletTerms: {
    description: 'BRT terms and conditions for wallet registration',
    defaultMessage: 'BRT Terms and Conditions',
    id: 'NaN72Z',
  },
  CorreosExpressWalletTerms: {
    description: 'Correos Express terms and conditions for wallet registration',
    defaultMessage: 'Correos Express Terms and Conditions',
    id: 'iDaGyC',
  },
  NonDefaultTerms: {
    description: 'Checkbox label for the non-default seller provider Walleted Terms and Conditions',
    defaultMessage: 'I have read and agree to the following terms of service and request to activate all available services.',
    id: 'KJ3u4l',
  },
  180: {
    description: 'Checkbox label for the non-default seller provider Walleted Amazon Shipping',
    defaultMessage:
      'I have read and agree to the following terms of service and request to activate all available services for Amazon Shipping.',
    id: 'aYr6hd',
  },
  AustraliaPostMyPostBusinessWalletTerms: {
    description: 'Australia Post Terms and Conditions',
    defaultMessage: 'Australia Post Terms and Conditions',
    id: 'W9bOrs',
  },
  AustraliaPostMyPostBusinessWalletEcommercePartnerResellerTerms: {
    description: 'Australia Post eCommerce Partner Reseller - Delivery Service Terms & Conditions',
    defaultMessage: 'Australia Post eCommerce Partner Reseller - Delivery Service Terms & Conditions',
    id: 'mKcZBb',
  },
  AramexAUWalletConditionsOfCarriage: {
    description: 'Aramex AU Conditions of Carriage terms and conditions for wallet registration',
    defaultMessage: 'Aramex AU by ShipStation Conditions of Carriage',
    id: 'mxgROO',
  },
  RoyalMailClickAndDropWalletTerms: {
    description: 'Royal Mail Terms and Conditions for wallet registration',
    defaultMessage: 'Royal Mail: Terms and Conditions',
    id: '8ZPkdj',
  },
  ParcelforceRoyalMailClickAndDropWalletTerms: {
    description: 'Parcelforce Royal Mail Terms and Conditions for wallet registration',
    defaultMessage: 'Parcelforce Royal Mail: Terms and Conditions',
    id: 'MWo9vo',
  },
  DHLExpressMyDHLWalletTerms: {
    description: 'DHL Express MyDHL terms and conditions for wallet registration',
    defaultMessage: 'DHL Express Terms and Conditions',
    id: '5p7Wzg',
  },
  AmazonShippingWalletTerms: {
    description: 'Amazon Shipping by ShipStation terms and conditions for wallet registration',
    defaultMessage: 'Amazon Shipping by ShipStation Terms and Conditions',
    id: 'Pdb1OW',
  },
  HubbedWalletedTerms: {
    description: 'PARCELPOINT by ShipStation (Powered by Hubbed) terms and conditions for wallet registration',
    defaultMessage: 'PARCELPOINT by ShipStation (Powered by Hubbed) Terms and Conditions',
    id: 'WF7bUt',
  },
  ColissimoWalletedTerms: {
    description: 'Colissimo Terms and Conditions for wallet registration',
    defaultMessage: 'Colissimo Terms and Conditions',
    id: 'WKdy04',
  },
});
